import { render, staticRenderFns } from "./after-buy.vue?vue&type=template&id=5b72ba1c&scoped=true&"
import script from "./after-buy.vue?vue&type=script&lang=ts&"
export * from "./after-buy.vue?vue&type=script&lang=ts&"
import style0 from "./after-buy.vue?vue&type=style&index=0&id=5b72ba1c&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b72ba1c",
  null
  
)

export default component.exports